import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import AdminOptions from "../pages/dashboardPage/adminOptions/AdminOptions";
import AppVersionSettings from "../pages/dashboardPage/appVersionSettings/AppVersionSettings";
import CustomerService from "../pages/dashboardPage/customerService/CustomerService";
import EmployeeSettings from "../pages/dashboardPage/emloyeeSettings/EmployeeSettings";
import RegionSettings from "../pages/dashboardPage/regionSettings/RegionSettings";
import SocialMediaSettings from "../pages/dashboardPage/socialMediaSettings/SocialMediaSettings";
import Timeline from "../pages/dashboardPage/timeline/Timeline";
import TournamentSettings from "../pages/dashboardPage/tournamentSettings/TournamentSettings";
import TournmentTables from "../pages/dashboardPage/tournamentTables/TournmentTables";
import UserSettings from "../pages/dashboardPage/userSettings/UserSettings";
import TournamentsComments from "../pages/dashboardPage/tournamentsComments/TournamentsComments";
import SquadSettings from "../pages/dashboardPage/squadSettings/SquadSettings";
import Logs from "../pages/dashboardPage/logs/Logs";

const DashboardInnerNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);

  return (
    <Routes>
      {rolePermissions.includes("overview") && (
        <Route path="/admin-options/*" element={<AdminOptions />} />
      )}
      {rolePermissions.includes("control-admins") && (
        <Route path="/emlpoyees/*" element={<EmployeeSettings />} />
      )}
      {rolePermissions.includes("view-logs") && (
        <Route path="/logs/*" element={<Logs />} />
      )}
      {rolePermissions.includes("control-tournaments") && (
        <Route path="/tournaments/*" element={<TournamentSettings />} />
      )}
      {rolePermissions.includes("control-regions") && (
        <Route path="/regions/*" element={<RegionSettings />} />
      )}
      {rolePermissions.includes("control-users") && (
        <Route path="/users/*" element={<UserSettings />} />
      )}
      {rolePermissions.includes("control-squads") && (
        <Route path="/squads/*" element={<SquadSettings />} />
      )}
      {rolePermissions.includes("control-tables") && (
        <Route path="/timelines/*" element={<Timeline />} />
      )}
      {rolePermissions.includes("control-tables") && (
        <Route path="/tournament-tables/*" element={<TournmentTables />} />
      )}
      {rolePermissions.includes("control-chat") && (
        <Route path="/customer-support/*" element={<CustomerService />} />
      )}
      {rolePermissions.includes("control-tournament-comments") && (
        <Route
          path="/tournaments-comments/*"
          element={<TournamentsComments />}
        />
      )}
      {rolePermissions.includes("control-socialmedia") && (
        <Route path="/social-media/*" element={<SocialMediaSettings />} />
      )}
      {rolePermissions.includes("control-appVersion") && (
        <Route path="/app-settings/*" element={<AppVersionSettings />} />
      )}
    </Routes>
  );
};

export default DashboardInnerNavigator;
